import { QueryType } from '@/app/types/types'
import { apiClient } from '..'
import axios from 'axios'

export const createCandidateNoteRequest = async (query: QueryType) => {
    return apiClient().post('/api/notes', query)
}

export const getAllCandidateNotesRequest = async (query: QueryType) => {
    return apiClient().get('/api/notes', {
        params: query,
    })
}

export const getOneCandidateNoteRequest = async (id: number, params: QueryType) => {
    return apiClient().get(`/api/notes/${id}`, {
        params,
    })
}

export const updateCandidateNoteRequest = async (id: number, query: QueryType) => {
    return await apiClient().put(`/api/notes/${id}`, query)
}

export const deleteCandidateNoteRequest = async (id: number, params: QueryType) => {
    return await axios.delete(`/api/notes/${id}`, {
        params,
    })
}

export const getNotesByEmailRequest = async (candidateEmail: string, companyId: number) => {
    return apiClient().get('/api/notes/by-email', {
        params: {
            candidateEmail,
            companyId,
        },
    })
}
